import React from "react";
import {BlockMath} from "react-katex";
import * as Support from "../../../canonicalNumericTaskSupport";
export const {renderInput,checkAnswer,renderAnswer,renderExplanation,renderUserAnswer}=Support;
const pick=items=>items[Math.floor(Math.random()*items.length)];

export function generateTask(options={}){
 const degree=options.degree===5?5:3;
 const answer=-pick(degree===5?[2,3]:[2,3,4,5]);
 const radicand=answer**degree;
 return {type:"OddRootValueTask",data:{degree,radicand,answer,steps:[
  {text:"Pierwiastek nieparzystego stopnia z liczby ujemnej jest ujemny. Szukamy liczby, której odpowiednia potęga daje liczbę pod pierwiastkiem.",math:`(${answer})^{${degree}}=${radicand}`},
  {text:"Zatem:",math:`\\sqrt[${degree}]{${radicand}}=${answer}`},
 ]}};
}
export function renderTask({data}){return <div><p>Oblicz pierwiastek.</p><BlockMath math={`\\sqrt[${data.degree}]{${data.radicand}}`}/></div>;}
export const registry={OddRootValueTask:{generateTask,renderTask,...Support}};
